export default {
    pageTitle: {
        appointments: 'Import Appointments',
        campaigns: 'Import Contacts',
        contacts: 'Import Contacts',
    },
    list: {
        noImports: 'No imports.',
    },
    steps: {
        uploadTitle: 'Upload File',
        uploadDescription: 'Upload a CSV or XLSX file.',
        matchTitle: 'Column Matching',
        matchDescription: 'Assign the columns to their respective attribute.',
        previewTitle: 'Preview',
        previewDescription: 'Preview the result before importing.',
    },
    confirmLeavingModal: {
        header: 'Do you want to leave this page?',
        message: 'If you leave the import process now, it won\'t be completed.',
    },
    upload: {
        allowedFileType: 'Allowed file types: {types}.',
        dropFile: 'Drop it like it\'s hot.',
        invalidFileType: 'Invalid file type.',
        removeFile: 'Remove',
        viewFile: 'View',
        upload: 'Upload',
        validateNumbers: 'Validate mobile phone numbers',
        validateNumbersTooltip: 'Enable this option to ensure that the numbers are valid cell phones',
        uploadError: 'Server error. Please verify that the file is valid.',
    },
    columnMatching: {
        appointmentNotes: 'Notes (appointment)',
        belongsTo: 'Belongs to...',
        btnPreview: 'Preview',
        columnName: 'Column name:',
        communicationPreference: 'Communication preference',
        contactNotes: 'Notes (contact)',
        date: 'Date',
        datetime: 'Date & Time',
        email: 'Email',
        firstName: 'First name',
        fullName: 'Full name',
        lastName: 'Last name',
        locale: 'Language',
        name: 'Name',
        new: 'New attribute',
        phone: 'Phone',
        none: 'Skip',
        time: 'Time',
        unsubscribed: 'Unsubscribed',
        actions: 'Actions',
    },
    preview: {
        appointmentNotes: 'Notes (appointment)',
        btnImport: 'Import',
        communicationPreference: 'Comm. preference',
        communicationPreferences: {
            sms: 'SMS',
            phone: 'Phone',
            email: 'Email',
        },
        contactNotes: 'Notes (contact)',
        date: 'Date',
        email: 'Email',
        firstHundredOnly: 'Only the first 100 rows are shown above.',
        importModal: {
            header: 'Ready to import?',
            message: 'Did you validate all the data in the preview table?',
        },
        invalidData: 'Required data missing or invalid',
        invalidDate: 'Invalid date',
        missingOptionalData: 'Missing optional data',
        missingRequiredDate: 'Missing required data',
        moreColumns: '... and {number} more',
        name: 'Name',
        phone: 'Phone',
        status: 'Status',
        successMessage: 'Import in progress...',
    },
    result: {
        import: 'Import',
        status: 'Status',
        types: {
            appointment: 'Appointments',
            contact: 'Contacts',
            campaign: 'Campaign',
        },
    },
};
